import { SVGProps } from 'react';

const Cross: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Action/cross">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.34315 6.34313C5.95262 6.73366 5.95262 7.36682 6.34315 7.75735L10.5858 12L6.34315 16.2426C5.95262 16.6332 5.95262 17.2663 6.34315 17.6568C6.73367 18.0474 7.36683 18.0474 7.75736 17.6568L12 13.4142L16.2426 17.6568C16.6332 18.0474 17.2663 18.0474 17.6569 17.6568C18.0474 17.2663 18.0474 16.6332 17.6569 16.2426L13.4142 12L17.6569 7.75735C18.0474 7.36682 18.0474 6.73366 17.6569 6.34313C17.2663 5.95261 16.6332 5.95261 16.2426 6.34313L12 10.5858L7.75736 6.34313C7.36684 5.95261 6.73367 5.95261 6.34315 6.34313Z"
        fill="#4B4F54"
      />
    </g>
  </svg>
);

export default Cross;
